/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigMatrix
 */
export interface ConfigMatrix {
    /**
     * 
     * @type {string}
     * @memberof ConfigMatrix
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatrix
     */
    portfolio?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatrix
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatrix
     */
    category: string;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatrix
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatrix
     */
    description?: string | null;
    /**
     * 
     * @type {ConfigMatrixValueTypeEnum}
     * @memberof ConfigMatrix
     */
    valueType: ConfigMatrixValueTypeEnum;
    /**
     * Defines which key dimensions are required: LobAndOffice (both required), LobOnly (office=*), OfficeOnly (lob=*), Unrestricted (any combination)
     * @type {ConfigMatrixKeyTypeEnum}
     * @memberof ConfigMatrix
     */
    keyType: ConfigMatrixKeyTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ConfigMatrix
     */
    displayFormat: string;
}


/**
 * @export
 */
export const ConfigMatrixValueTypeEnum = {
    Amount: 'Amount',
    Percent: 'Percent',
    Boolean: 'Boolean',
    Text: 'Text'
} as const;
export type ConfigMatrixValueTypeEnum = typeof ConfigMatrixValueTypeEnum[keyof typeof ConfigMatrixValueTypeEnum];

/**
 * @export
 */
export const ConfigMatrixKeyTypeEnum = {
    LobOffice: 'LobOffice',
    Lob: 'Lob',
    Office: 'Office',
    Global: 'Global'
} as const;
export type ConfigMatrixKeyTypeEnum = typeof ConfigMatrixKeyTypeEnum[keyof typeof ConfigMatrixKeyTypeEnum];


/**
 * Check if a given object implements the ConfigMatrix interface.
 */
export function instanceOfConfigMatrix(value: object): value is ConfigMatrix {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('valueType' in value) || value['valueType'] === undefined) return false;
    if (!('keyType' in value) || value['keyType'] === undefined) return false;
    if (!('displayFormat' in value) || value['displayFormat'] === undefined) return false;
    return true;
}

export function ConfigMatrixFromJSON(json: any): ConfigMatrix {
    return ConfigMatrixFromJSONTyped(json, false);
}

export function ConfigMatrixFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigMatrix {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'portfolio': json['portfolio'] == null ? undefined : json['portfolio'],
        'key': json['key'],
        'category': json['category'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'valueType': json['valueType'],
        'keyType': json['keyType'],
        'displayFormat': json['displayFormat'],
    };
}

export function ConfigMatrixToJSON(json: any): ConfigMatrix {
    return ConfigMatrixToJSONTyped(json, false);
}

export function ConfigMatrixToJSONTyped(value?: ConfigMatrix | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'portfolio': value['portfolio'],
        'key': value['key'],
        'category': value['category'],
        'name': value['name'],
        'description': value['description'],
        'valueType': value['valueType'],
        'keyType': value['keyType'],
        'displayFormat': value['displayFormat'],
    };
}

